var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-manager",class:_vm.classList},[_c('navbar'),_c('sidebar'),_c('main',{staticClass:"app-view-container"},[_c('router-view',{staticClass:"app-view"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }